var more = document.querySelectorAll('.expand__more');

var moreToggle = function() {
  this.parentNode.previousElementSibling.classList.toggle('expand__content--active');
  this.style.display = 'none';
};

for (var i = 0; i < more.length; i += 1) {
  more[i].addEventListener('click', moreToggle);
}
